import { render, staticRenderFns } from "./Prepare.vue?vue&type=template&id=6cb947c6"
import script from "./Prepare.vue?vue&type=script&lang=ts"
export * from "./Prepare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports